import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=772ffaee&"
import script from "./CustomReport.vue?vue&type=script&lang=ts&"
export * from "./CustomReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports